<template>
  <div
    @click="openFreemiumModal"
    class="c--freemium_banner freemium-banner tw-shadow tw-h-[75px] tw-w-full tw-rounded tw-py-[15px] tw-px-5 tw-relative tw-cursor-pointer tw-content-center tw-flex tw-items-center"
    data-testid="freemium-banner"
  >
    <div class="tw-w-full tw-flex tw-justify-between tw-items-center ltr:tw-pl-[110px] rtl:tw-pr-[110px]">
      <div class="heading tw-text-primary tw-text-14 lg:tw-text-4 tw-font-semibold tw-leading-6">
        {{ $t('components.freemium.how-to-get-free-esim') }}
      </div>

      <i class="airalo-icon-arrow-right tw-text-primary" />
    </div>

    <HowFreemiumWorks :view-modal="modalOpen" @onClose="closeFreemiumModal" />
    <FreemiumIncompatible :view-modal="incompatibleModalOpen" @onClose="closeFreemiumModal" />
  </div>
</template>

<script>
  import HowFreemiumWorks from '@/components/freemium/how-freemium-works.vue'
  import FreemiumIncompatible from '@/components/freemium/freemium-incompatible.vue'

  export default {
    components: {
      FreemiumIncompatible,
      HowFreemiumWorks,
    },
    data() {
      return {
        modalOpen: false,
        incompatibleModalOpen: false,
      }
    },
    methods: {
      openFreemiumModal() {
        if (this.$featureFlag.isActive('freemium_web_checkout')) {
          this.modalOpen = true
          this.$utils.sendEvent('freemiumBannerTapped')
        } else {
          this.incompatibleModalOpen = true
        }
      },
      closeFreemiumModal() {
        this.modalOpen = false
        this.incompatibleModalOpen = false
      },
    },
  }
</script>

<style lang="scss">
  .freemium-banner {
    background: url(/assets/images/freemium/freemium-banner-small.svg) no-repeat,
      linear-gradient(90deg, #ffc371 0%, #ffeb82 100%);
    [dir='rtl'] & {
      background-position: right 0;
    }
  }
</style>
